import React from 'react';

export default function ErrorIcon(props) {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 5.6V8M8 10.4H8.006M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}